import SparringProjectSelector from './src/main';

/* istanbul ignore next */
SparringProjectSelector.install = function(Vue) {
  Vue.component(SparringProjectSelector.name, SparringProjectSelector);
};

export default SparringProjectSelector;
